<template>
    <div>
        <div>
            <span class="activity-name font-weight-medium">{{ item.person | format_name }} </span>
            <span class="activity-type">{{ taskLogType }}</span>
        </div>
        <Footer :created_at="item.created_at"/>
    </div>
</template>

<script>
import {$t} from "@/i18n";
import Footer from '../Footer'
import {computed} from "@vue/composition-api";
import {TASK_LOG_TYPE} from "../../../../helpers/constants";

export default {
    name: "ActivityRow",
    components: {
        Footer
    },
    props: {
        item: {
            type: Object,
            default: null
        }
    },
    setup(props, ctx) {
        const taskLogType = computed(() => {
            let data = {};

            const createdForList = props.item.data && props.item.data.created_for ? props.item.data.created_for : null
            let createdFor = $t('Unknown')
            if (createdForList) {
                if (createdForList.length) {
                    createdFor = createdForList.join(', ')
                } else {
                    createdFor = $t('no one')
                }
            }

            // notice :: TASK_LOG_TYPE
            data[TASK_LOG_TYPE.TASK_CREATED] = $t('created this task.')
            data[TASK_LOG_TYPE.TASK_CREATED_EMAIL] = $t('Task was automatically created from forwarded e-mail')
            data[TASK_LOG_TYPE.TASK_CREATED_SUMMARY_EMAIL] = $t('Task was automatically created from client portal e-mail')
            data[TASK_LOG_TYPE.TASK_CREATED_CLIENT_EMAIL] = $t('Task was automatically created from client e-mail')
            data[TASK_LOG_TYPE.TASK_CREATED_PROJECT_EMAIL] = $t('Task was automatically created from project e-mail')
            data[TASK_LOG_TYPE.REQUEST_CREATED] = $t('requested assistance.')
            data[TASK_LOG_TYPE.TASK_UPDATED] = $t('updated this task.')
            data[TASK_LOG_TYPE.TASK_IN_PROGRESS] = $t('tracked time to this task.')
            data[TASK_LOG_TYPE.TASK_FINISHED] = $t('finished this task.')
            data[TASK_LOG_TYPE.TASK_COMMENT] = $t('new comment.')
            data[TASK_LOG_TYPE.TASK_ASSIGNED] = $t('reassigned this task.')
            data[TASK_LOG_TYPE.TASK_ASSIGNED_CP] = $t('assigned the task to {0}.').format(createdFor)
            data[TASK_LOG_TYPE.TASK_REMINDER] = $t('reminder.')
            data[TASK_LOG_TYPE.TASK_DELETED] = $t('deleted.')
            data[TASK_LOG_TYPE.TASK_AUTO_FINISH_FAILED] = $t('completed the task, but Uku did not auto-finish this task because not all task requirements were met.')
            data[TASK_LOG_TYPE.TASK_CHANGE_IS_CP] = $t('sent task to client portal')
            data[TASK_LOG_TYPE.TASK_OPENED] = $t('assigned the task to client.')
            data[TASK_LOG_TYPE.TASK_CLOSED] = $t('assigned the task to company.')
            data[TASK_LOG_TYPE.TASK_ATTACHMENT_ADDED] = $t('added attachment(s).')
            data[TASK_LOG_TYPE.TASK_COMMENT_ADDED] = $t('added a comment.')
            data[TASK_LOG_TYPE.TASK_MESSAGE_ADDED] = $t('added a message to {0}.').format(createdFor)
            data[TASK_LOG_TYPE.TASK_MESSAGE_FROM_TASK_EMAIL_ADDED] = $t('received a e-mail from {0}.').format(createdFor)
            data[TASK_LOG_TYPE.TASK_NOTE_UPDATED] = $t('updated notes.')
            data[TASK_LOG_TYPE.TASK_CHECKLIST_UPDATED] = $t('made changes to checklist.')

            data[TASK_LOG_TYPE.TASK_TEMPLATE_CREATED] = $t('created this task template.')
            data[TASK_LOG_TYPE.TASK_TEMPLATE_UPDATED] = $t('updated this task template.')
            data[TASK_LOG_TYPE.TASK_TEMPLATE_ASSIGNED] = $t('recurring task assigned.')
            data[TASK_LOG_TYPE.TASK_TEMPLATE_DELETED] = $t('recurring task deleted.')

            data[TASK_LOG_TYPE.TASK_EMAIL_ADDED] = $t('added email.')
            data[TASK_LOG_TYPE.TASK_EMAIL_CHANGED] = $t('changed email.')
            data[TASK_LOG_TYPE.TASK_EMAIL_DELETED] = $t('deleted email.')
            data[TASK_LOG_TYPE.TASK_EMAIL_SEND_SUCCESS] = $t('sent email.')
            data[TASK_LOG_TYPE.TASK_EMAIL_SEND_FAILED] = $t('failed to send.')

            return props.item.type in data ? data[props.item.type] : props.item.type
        })

        return {
            taskLogType
        }
    }
}
</script>

<style scoped>

</style>